import type {RouteRecordRaw} from 'vue-router';

import {ERoleSystem} from '@/api/enums/role';

import {ECRoutesNames} from '@/app/client/router/enums';
import {ESettingsFrontType} from '@/config/enums';

export const clientBaseRoutes: Array<RouteRecordRaw> = [
  {
    path: '/not-found',
    name: ECRoutesNames.CNotFoundPage,
    meta: {
      access_mode: [ESettingsFrontType.CLIENT],
      access_roles: [ERoleSystem.ADMIN, ERoleSystem.USER],
    },
    component: () => import('@/app/base/pages/NotFoundPage.vue'),
  },
  {
    path: '/forbidden',
    name: ECRoutesNames.CForbiddenPage,
    meta: {
      access_mode: [ESettingsFrontType.CLIENT],
      access_roles: [ERoleSystem.ADMIN, ERoleSystem.USER, ERoleSystem.GUEST],
    },
    component: () => import('@/app/base/pages/ForbiddenPage.vue'),
  },
];
